import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import ValidatedSelect from "../../components/ValidatedSelect/ValidatedSelect";
import ButtonFotter from "../../components/Button/ButtonFotter/ButtonFotter";
import ValidatedInput from "../../components/ValidatedInput/ValidatedInput";
import StatesCitiesData from "../../assets/colombia_states_sales_force.json";
import Typography from "../../components/Typography/Typography";
import Divider from "../../components/Divider/Divider";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import Modal from "../../components/Modal/Modal";
import styles from "./PersonalData.module.scss";
import codes from "../../utils/codes";

import { days, monthNumbers, years } from "../../utils/utils";
import { validateEmailCelphone } from "../../utils/services";
import { StateContext } from "../../contexts/state.context";
import { formatCellphone } from "../../utils/functions";
import {
	emailValidate,
	textValidate,
	phoneValidate,
} from "../../utils/validators";

const PersonalData = () => {
	const navigate = useNavigate();
	const outletContext = useOutletContext();
	const setShellFooter = outletContext?.setShellFooter;
	const { formData, setFormData } = useContext(StateContext);

	const birthDate = formData?.fechaNacimiento?.split("/") || null;

	// When Identica is bypassed, nombres/apellidos come empty; user must fill them.
	const [nombres, setNombres] = useState(formData?.nombres ?? "");
	const [apellidos, setApellidos] = useState(formData?.apellidos ?? "");

	const [birthDay, setBirthDay] = useState(birthDate ? birthDate[0] : null);
	const [brithYear, setBirthYear] = useState(birthDate ? birthDate[2] : null);
	const [birthMonth, setBirthMonth] = useState(
		birthDate ? birthDate[1] : null,
	);
	const [birthDateError, setBirthDateError] = useState(false);

	const [gender, setGender] = useState(formData?.gender);
	const [genderError, setGenderError] = useState(false);

	const [celphone, setCelphone] = useState(formData?.celphone);
	const [celphoneError, setCelphoneError] = useState();
	const [email, setEmail] = useState(formData?.email);
	const [emailError, setEmailError] = useState();
	const [addr, setAddr] = useState(formData?.addr);
	const [addrError, setAddrError] = useState();
	const [city, setCity] = useState(formData?.city);
	const [cityError, setCityError] = useState();
	const [state, setState] = useState(formData?.state);
	const [stateError, setStateError] = useState();

	const [cities, setCities] = useState([]);
	const [loader, setLoader] = useState(false);

	const [wrongDataModal, setWrongDataModal] = useState(false);
	const [wrongDataMjsModal, setWrongDataMjsModal] = useState("");
	const [wrongDataTitleModal, setWrongDataTitleModal] = useState("");

	const [nombresError, setNombresError] = useState(false);
	const [apellidosError, setApellidosError] = useState(false);

	const namesLocked = useMemo(() => {
		const n = String(formData?.nombres ?? "").trim();
		const a = String(formData?.apellidos ?? "").trim();
		return n.length >= 2 && a.length >= 2;
	}, [formData?.nombres, formData?.apellidos]);

	const validateGender = () => {
		if (!gender || gender === "Selecciona tu género") return true;
		return false;
	};

	const validateBirthDate = () => {
		if (
			!birthMonth ||
			!brithYear ||
			!birthDay ||
			birthMonth === "Mes" ||
			brithYear === "Año" ||
			birthDay === "Día"
		)
			return true;

		const d = Number(birthDay);
		const m = Number(birthMonth);
		const y = Number(brithYear);
		const birth = new Date(y, m - 1, d);
		if (
			birth.getFullYear() !== y ||
			birth.getMonth() !== m - 1 ||
			birth.getDate() !== d
		) {
			console.error("Invalid Date");
			return true;
		}
		const today = new Date();

		const limit = new Date(
			today.getFullYear() - 18,
			today.getMonth(),
			today.getDate(),
		);
		if (birth > limit) {
			console.error("TOO Young");
			return true;
		}

		return false;
	};

	const validateData = () => {
		setNombresError(false);
		setApellidosError(false);

		// Always require nombre and apellido until Identica is available.
		const n = (nombres || "").trim();
		const a = (apellidos || "").trim();
		if (!n || n.length < 2 || n.length > 60) {
			setNombresError(true);
			return false;
		}
		if (!a || a.length < 2 || a.length > 60) {
			setApellidosError(true);
			return false;
		}

		if (validateBirthDate()) {
			setBirthDateError(true);
			return false;
		}

		if (validateGender()) {
			setGenderError(true);
			return false;
		}

		if (!celphone || !phoneValidate(celphone)) {
			setCelphoneError(true);
			return false;
		}

		if (!email || !emailValidate(email)) {
			setEmailError(true);
			return false;
		}

		if (!addr || !textValidate(addr)) {
			setAddrError(true);
			return false;
		}

		if (!state || !textValidate(state)) {
			setStateError(true);
			return false;
		}

		if (!city || !textValidate(city)) {
			setCityError(true);
			return false;
		}

		return true;
	};

	const handleStateSelect = (state) => {
		setState(state);
		setCity(null);
		const index = StatesCitiesData.departamentos.indexOf(state);
		setCities(StatesCitiesData.ciudades[index]);
	};

	const handleBtnDisabled = () => {
		const baseFields =
			birthDay &&
			brithYear &&
			birthMonth &&
			gender &&
			celphone &&
			email &&
			addr &&
			city &&
			state;
		const n = (nombres || "").trim();
		const a = (apellidos || "").trim();
		const namesFilled = n.length >= 2 && a.length >= 2;
		if (baseFields && namesFilled) return false;
		return true;
	};

	const handleContinueClick = () => {
		if (!validateData()) {
			return;
		}

		const rData = {
			id: formData.id,
			docType: formData.docType,
			fechaExpedicionDocumento: formData.fechaExpedicionDocumento,
			nombres: nombres || formData.nombres,
			apellidos: apellidos || formData.apellidos,
			captchaToken: formData.captchaToken,
			fechaNacimiento: `${birthDay}/${birthMonth}/${brithYear}`,
			gender,
			celphone,
			email,
			addr,
			city,
			state,
		};

		setFormData(rData);
		setLoader(true);

		validateEmailCelphone({ formInfo: { email, celphone } })
			.then(({ code, message }) => {
				setLoader(false);
				const { emailVerResponse, phoneVerResponse } = message;

				switch (code) {
					case codes.JVB001.code:
						navigate("/register/last-steps");
						break;

					case codes.JVB004.code:
						setWrongDataModal(true);
						if (emailVerResponse.exists) {
							setEmailError(true);
							setWrongDataTitleModal(
								"Correo electrónico ya registrado.",
							);
							setWrongDataMjsModal(
								"El correo que ingresaste ya está en uso por otra cuenta. Por favor, utiliza un correo diferente.",
							);
						}

						if (phoneVerResponse.exists) {
							setCelphoneError(true);
							setWrongDataTitleModal(
								"Número de celular ya registrado.",
							);
							setWrongDataMjsModal(
								"Este número ya está asociado a otra cuenta. Ingresa un número diferente para continuar.",
							);
						}

						break;

					default:
						break;
				}
			})
			.catch((e) => {
				console.log(e.data);
				setLoader(false);
			});
	};

	useEffect(() => {
		if (!setShellFooter) return;
		setShellFooter(
			<ButtonFotter
				dock="panel"
				onClick={handleContinueClick}
				disabled={handleBtnDisabled()}
			>
				Continuar
			</ButtonFotter>,
		);
		return () => setShellFooter(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- re-run when inputs change; handlers use latest closure
	}, [
		setShellFooter,
		birthDay,
		brithYear,
		birthMonth,
		gender,
		celphone,
		email,
		addr,
		city,
		state,
		nombres,
		apellidos,
	]);

	// Redirect only when step 1 was never completed (no formData). When Identica
	// is bypassed, apellidos/nombres can be empty and user fills them here.
	useEffect(() => {
		if (!formData) navigate("/");
	}, [formData, navigate]);

	return (
		<div className={styles.personalDataContainer}>
			{/* Nombre y apellido siempre obligatorios hasta tener Identica */}
			<ValidatedInput
				className={styles.personalDataTextInput}
				label="Nombres"
				placeholder={
					namesLocked
						? nombres
						: "Escribe tus nombres (mín. 2 caracteres)"
				}
				value={nombres}
				readOnly={namesLocked}
				onChange={(v) => {
					if (namesLocked) {
						return;
					}
					setNombres(v);
					setNombresError(false);
				}}
				error={nombresError}
				setError={setNombresError}
				errorMessage="Ingresa al menos 2 caracteres"
			></ValidatedInput>
			<ValidatedInput
				className={styles.personalDataTextInput}
				label="Apellidos"
				placeholder={
					namesLocked
						? apellidos
						: "Escribe tus apellidos (mín. 2 caracteres)"
				}
				value={apellidos}
				readOnly={namesLocked}
				onChange={(v) => {
					if (namesLocked) {
						return;
					}
					setApellidos(v);
					setApellidosError(false);
				}}
				error={apellidosError}
				setError={setApellidosError}
				errorMessage="Ingresa al menos 2 caracteres"
			></ValidatedInput>

			<Divider className={styles.personalDataDivider}></Divider>

			<div className={styles.personalDataContent}>
				<div className={styles.personalDataBirthDateSelectContainer}>
					<Typography
						className={styles.personalDataTextInputContainer}
						variant="h6"
						bold
					>
						Fecha de nacimiento
					</Typography>

					<div className={styles.personalDataBirthDateContainer}>
						<ValidatedSelect
							placeholder={birthDay || "Día"}
							options={days}
							onChange={setBirthDay}
							error={birthDateError}
							setError={setBirthDateError}
							center
						></ValidatedSelect>
						<ValidatedSelect
							placeholder={birthMonth || "Mes"}
							options={monthNumbers}
							onChange={setBirthMonth}
							error={birthDateError}
							setError={setBirthDateError}
							center
						></ValidatedSelect>
						<ValidatedSelect
							placeholder={brithYear || "Año"}
							options={years}
							onChange={setBirthYear}
							error={birthDateError}
							setError={setBirthDateError}
							center
						></ValidatedSelect>
					</div>

					<Typography
						className={styles.personalDataBirthDateError}
						variant="p2"
						color={birthDateError ? "red" : "transparent"}
					>
						Fecha inválida
					</Typography>
				</div>

				<ValidatedSelect
					className={styles.personalDataGenderSelect}
					label="Género"
					placeholder={formData?.gender || "Selecciona tu género"}
					options={["Mujer", "Hombre", "Otro", "Sin información"]}
					onChange={setGender}
					error={genderError}
					errorMessage="Campo inválido"
					setError={setGenderError}
				></ValidatedSelect>
			</div>

			<ValidatedInput
				className={styles.personalDataTextInput}
				label="Celular"
				placeholder={
					formData?.celphone || "Escribe tu número de celular"
				}
				type="text"
				inputMode="tel"
				onChange={setCelphone}
				error={celphoneError}
				errorMessage="Ingresa un número de celular válido"
				setError={setCelphoneError}
				formatter={formatCellphone}
			></ValidatedInput>

			<ValidatedInput
				className={styles.personalDataTextInput}
				label="Correo electrónico"
				placeholder={formData?.email || "Escribe tu correo electrónico"}
				onChange={setEmail}
				error={emailError}
				errorMessage="Ingresa un correo electrónico válido"
				setError={setEmailError}
				autoCapitalize="none"
			></ValidatedInput>

			<ValidatedInput
				className={styles.personalDataTextInput}
				label="Dirección"
				placeholder={formData?.addr || "Escribe tu dirección"}
				onChange={setAddr}
				error={addrError}
				setError={setAddrError}
			></ValidatedInput>

			<ValidatedSelect
				className={styles.personalDataTextInput}
				label="Departamento"
				placeholder={formData?.state || "Selecciona un departamento"}
				options={StatesCitiesData.departamentos}
				onChange={handleStateSelect}
				error={stateError}
				errorMessage="Campo inválido"
				setError={setStateError}
			></ValidatedSelect>

			<ValidatedSelect
				className={styles.personalDataTextLast}
				label="Ciudad"
				placeholder={formData?.city || "Selecciona una ciudad"}
				options={cities}
				onChange={setCity}
				error={cityError}
				errorMessage="Campo inválido"
				setError={setCityError}
			></ValidatedSelect>

			{loader && <Loader />}

			{wrongDataModal && (
				<Modal
					title={wrongDataTitleModal}
					onClose={() => setWrongDataModal(false)}
				>
					<div>
						<Typography className={styles.modalText}>
							{wrongDataMjsModal}
						</Typography>

						<Button
							className={styles.modalBtn}
							onClick={() => setWrongDataModal(false)}
						>
							Volver
						</Button>
					</div>
				</Modal>
			)}

		</div>
	);
};

export default PersonalData;
